import { Editor } from "@tinymce/tinymce-react";

const TinyMCEEditor = ({
  apiKey = "ro0g7je56g20q2msq0mgpr0j85fj9w2ur256f3of4gpr1xa2",
  value = "",
  onEditorChange = (e: any) => {},
  height = 200,
  menubar = false,
  plugins = ["lists link code"],
  toolbar = "undo redo | formatselect | bold italic underline | bullist numlist | link code",
  id = "",
}) => {
  return (
    <Editor
      id={id}
      apiKey={apiKey}
      value={value}
      onEditorChange={onEditorChange}
      init={{
        height,
        menubar,
        plugins,
        toolbar,
        branding: false,
      }}
    />
  );
};

export default TinyMCEEditor;
